import { AccountStatus } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "ログインID",
    keyword: "loginId",
    type: "text",
  },
  {
    title: "ステータス",
    keyword: "status",
    type: "radio",
    radioPropsList: TkGetCodeList(AccountStatus),
    requiredIcon: true,
  },
  {
    title: "契約者名",
    keyword: "contractorName",
    type: "text",
  },
  {
    title: "利用者名",
    keyword: "userName",
    type: "name",
    firstNameLabel: true,
    inputProps: { maxLength: 48 },
    requiredIcon: true,
  },
  {
    title: "連絡先メールアドレス",
    keyword: "contact",
    type: "mail",
    inputProps: { maxLength: 85 },
    requiredIcon: true,
  },
  {
    title: "連絡先メールアドレス（確認用）",
    keyword: "contactConfirm",
    type: "mail",
    inputProps: { maxLength: 85 },
    requiredIcon: true,
  },
];

const schema = {
  status: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  userName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  contact: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  contactConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export { fakeTableList, schema };
